import _ from 'lodash'

import { ApiFee } from '@/api'
import { Space } from '@/components/core-v2'
import { formatFees } from '@/modules/tradebuilder-v2/util'

import { reorderItemListsToMatchById } from '../../utils'
import { ProposedChangesModalFeeTable } from './proposed-changes-modal-fee-table'
import { StyledVerticalDivider } from './styled-vertical-divider'

export const ProposedChangesModalFeesSection = ({
  currentFees,
  proposedFees
}: {
  currentFees: ApiFee[]
  proposedFees: ApiFee[]
}) => {
  const [currentFeesSorted, proposedFeesSorted] = reorderItemListsToMatchById({
    array1: currentFees,
    array2: proposedFees,
    mappingLogic: (fee: ApiFee) => [fee.feeId, fee]
  })

  currentFees = currentFeesSorted
  proposedFees = proposedFeesSorted
  const feesAreDifferent = !_.isEqual(currentFees, proposedFees)

  return (
    <Space isflex flexGrow={1}>
      <Space isflex data-testid="current-fees" flexBasis="50%" mr={3}>
        <ProposedChangesModalFeeTable
          fees={formatFees(currentFees)}
          highlighted={feesAreDifferent}
        />
      </Space>
      <StyledVerticalDivider />
      <Space isflex data-testid="proposed-fees" flexBasis="50%" ml={3}>
        <ProposedChangesModalFeeTable
          fees={formatFees(proposedFees)}
          highlighted={feesAreDifferent}
        />
      </Space>
    </Space>
  )
}
